import { AsyncSubject } from '../AsyncSubject';
import { ConnectableObservable } from '../observable/ConnectableObservable';
export function publishLast() {
    const subject = new AsyncSubject();
    return (source) => new ConnectableObservable(source, () => subject);
}
//# sourceMappingURL=publishLast.js.map